// Mapeo de tipo_fortaleza (1–7) identificado desde el backend
// a un título amigable y su pregunta/origen.
export const FORTALEZA_META = {
  1: {
    titulo: "MIS RELACIONES FUERTES",
    origen: "¿Cómo establezco relaciones fuertes con los demás?",
  },
  2: {
    titulo: "ASÍ APRENDO Y RESUELVO PROBLEMAS",
    origen:
      "¿Cómo resuelves problemas? (Confirmar Talentos) y ¿Cómo aprendo? (Fortalezas)",
  },
  3: {
    titulo: "MI MOTIVACIÓN",
    origen: "¿Qué te motiva?",
  },
  4: {
    titulo: "LO QUE HAGO MEJOR",
    origen: "¿Qué haces con velocidad y precisión, mejor que los demás?",
  },
  5: {
    titulo: "MI ROL EN GRUPO",
    origen: "Tu rol dentro de un equipo (módulo Fortalezas)",
  },
  6: {
    titulo: "HACER LO QUE ME GUSTA",
    origen: "Todas las preguntas del módulo Aplicar",
  },
  7: {
    titulo: "MI RED DE APOYO",
    origen: "Relaciones significativas (módulo Fortalezas)",
  },
};

export const getFortalezaMeta = (tipo) => FORTALEZA_META[tipo] || null;
